import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromMetadata from './metadata.reducer';

export const selectMetadataStore = createFeatureSelector<fromMetadata.TInputAppMetadata>('metadataDB');

export const getOnlineStatus = createSelector(selectMetadataStore, (selectMetadataStore) => {
  return selectMetadataStore.isOnline;
});

export const getHealthCheckStatus = createSelector(selectMetadataStore, (selectMetadataStore) => {
  return selectMetadataStore.healthCheckPassed;
});

export const getEventsBatchCount = createSelector(selectMetadataStore, (selectMetadataStore) => {
  return selectMetadataStore.eventsBatchCount;
});

export const getEventsBatchCountAndOnlineStatus = createSelector(selectMetadataStore, (selectMetadataStore) => {
  return { eventsBatchCount: selectMetadataStore.eventsBatchCount, isOnline: selectMetadataStore.isOnline };
});

export const getMasterdataListStatuses = createSelector(selectMetadataStore, (selectMetadataStore) => {
  return selectMetadataStore.syncingInfo;
});

export const isScannerInitialised = createSelector(selectMetadataStore, (selectMetadataStore) => {
  return selectMetadataStore.isScannerInitialised;
});
